'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _httpClient = require('./httpClient');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BaseApi = function () {
  /**
   * Initializes new instance of BaseApi class.
   */
  function BaseApi(endpoint) {
    (0, _classCallCheck3.default)(this, BaseApi);
    this.endpoint = endpoint || '';
    this._apikey = process.env.JS_SDK_API_KEY || undefined;
    this._ioUserHeader = process.env.JS_SDK_IO_USER_HEADER || undefined;
    this._xApiKey = process.env.X_API_KEY || undefined;
  }

  /**
   * Returns current value of endpoint to be used as base URL when communicating with external apis eg. api.import.io.
   * @return {String}
   */

  (0, _createClass3.default)(BaseApi, [{
    key: 'makeRequest',
    /**
     * Prepends `this.endpoint` value and makes the request utilizing the httpClient utility.
     * @param  {Object} params Set of available parameters, the same as defined in `httpClient`.
     * @return {Promise}       Returns a promise resolving to the result of the request.
     */
    value: function makeRequest(params) {
      params.url = this.endpoint + '/' + (params.url || '');

      // Add api key to the request if one was provided in the SDK, and one isn't already set.
      if (this._apikey) {
        if (params.queryParameters && !params.queryParameters._apikey) {
          params.queryParameters._apikey = this._apikey;
        } else if (!params.queryParameters) {
          params.queryParameters = {
            _apikey: this._apikey
          };
        }
      }
      if (this._ioUserHeader) {
        if (params && params.headers) {
          params.headers['io-user'] = this._ioUserHeader;
        } else {
          params.headers = {
            'io-user': this._ioUserHeader
          };
        }
      }
      if (this._xApiKey) {
        if (params && params.headers) {
          params.headers['x-api-key'] = this._xApiKey;
        } else {
          params.headers = {
            'x-api-key': this._xApiKey
          };
        }
      }
      return (0, _httpClient.makeRequest)(params);
    }
  }, {
    key: 'endpoint',
    get: function get() {
      return this._endpoint;
    }

    /**
     * Sets a new value of apiEndpoint to be used as base URL when communicating with external apis.
     * @param  {String} val value to be set as current endpoint string.
     */,

    set: function set(val) {
      this._endpoint = val;
    }

    /**
     * Returns the current value of the api key.
     * @return {String}
     */
  }, {
    key: 'apiKey',
    get: function get() {
      return this._apikey;
    }

    /**
     * Sets a new value of the api key.
     * @param  {String} val value to be set as current api key string.
     */,

    set: function set(val) {
      this._apikey = val;
    }

    /**
     * Returns the current value of the api key.
     * @return {String}
     */
  }, {
    key: 'ioUserHeader',
    get: function get() {
      return this._ioUserHeader;
    }

    /**
     * Sets a new value of the api key.
     * @param  {String} val value to be set as current api key string.
     */,

    set: function set(val) {
      this._ioUserHeader = val;
    }

    /**
     * Returns the current value of the x-api key.
     * @return {String}
     */
  }, {
    key: 'xApiKey',
    get: function get() {
      return this._xApiKey;
    }

    /**
     * Sets a new value of the x-api key.
     * @param  {String} val value to be set as current x-api key string.
     */,

    set: function set(val) {
      this._xApiKey = val;
    }
  }]);
  return BaseApi;
}();
exports.default = BaseApi;